import { User } from "@auth0/auth0-react";
import * as Sentry from "@sentry/react";
import { useEffect } from "react";

export const useUpdateSentryUser = ({ user }: { user: User | undefined }) => {
  useEffect(() => {
    if (!user) return;
    Sentry.setUser({ email: user.email, username: user.name });
  }, [user]);
};
